import React, { useState } from "react";
import {
  makeStyles,
  Container,
  Modal,
  Grid,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@material-ui/core";
import { CancelButton, SubmitButton } from "../components-atoms";

export const ResolveDeliverySelectionModal = (props: any) => {
  const classes = useStyles();
  const [resolveAction, setResolveAction] = useState("");
  return (
    <Modal
      open={props.visible}
      onClose={props.onClose}
      aria-labelledby="Resolve failed delivery"
      className={classes.modal}
    >
      <Container className={classes.modalContainer}>
        <Grid container spacing={1}>
          <Grid item>
            <Typography variant="h6" component="h6" color="textPrimary">
              Resolve failed delivery
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="body2" component="p" color="textPrimary">
              Select a resolve action. After submitting the order will move the
              archieve section.
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <FormControl variant="outlined" className={classes.selectArea}>
              <InputLabel id="demo-simple-select-outlined-label">
                Select resolve action
              </InputLabel>
              <Select
                labelId="demo-simple-select-outlined"
                id="demo-simple-select-outlined"
                value={resolveAction}
                onChange={(event: any) => setResolveAction(event.target.value)}
                label="Select resolve action"
              >
                {["Delivered", "Refunded"].map((v: string, index: number) => (
                  <MenuItem key={index} value={v}>
                    {`Mark as ${v}`}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item container xs={12} justifyContent="flex-end">
            <CancelButton onClick={props.onClose} />
            <SubmitButton
              disabled={!resolveAction}
              onClick={() => props.onResolveButtonPressed(resolveAction)}
            />
          </Grid>
        </Grid>
      </Container>
    </Modal>
  );
};
const useStyles = makeStyles(() => ({
  modal: { alignItems: "center", justifyContent: "center" },
  modalContainer: {
    width: "480px",
    backgroundColor: "white",
    boxShadow:
      "0px 6px 36px rgba(0, 0, 0, 0.15), 0px 2.21728px 14.2392px rgba(0, 0, 0, 0.111884), 0px 0.93179px 6.99399px rgba(0, 0, 0, 0.0997219), 0px 0.37078px 3.36556px rgba(0, 0, 0, 0.0894965), 0px 0.120827px 1.42249px rgba(0, 0, 0, 0.0753326), 0px 0.0225271px 0.422798px rgba(0, 0, 0, 0.0508791)",
    borderRadius: "20px",
    padding: "24px",
    margin: "0",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  selectArea: {
    width: "100%",
    marginBottom: 15,
    marginTop: 24,
  },
}));
